import axios from 'axios'

export default {
    getEmails(page, filter, sorting) {
        var params = {
            page: page,
            serviceTicketId: filter.ticketId,
            email: filter.email,
            emailStatus: filter.emailStatus,
            selfService: filter.selfService,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder
        };
        return axios.get('/api/emails',
            {
                params: params
            });
    },
    resend(id) {
        return axios.post(`/api/emails/${id}/resend`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/emails/api.js